import { useEffect } from "react";

export function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("description", description);
  }, [title, description]);
}
